<template>

  <div id="home">
    <div v-if="isNavigate">
      <!-- THE SCREEN HAS HALF OVERLAY -->
      <div class="" v-if="isBack">
        <div class="backimage"></div>
        <div class="backform">
          <div v-if="isNumber == '1'" class="list-container">
            <div>
              <img src="../assets/tendu-logo.svg" alt="tendu logo" style="height:98px">
            </div>
            <div style="margin-top:10px; margin-bottom:10px;">
              <md-button v-if="!validUser.hash" class="md-raised" style="color:#C51162;"
                        @click.native="UPDATE_NUMBER(2), openDialog('dialog1')">Anmelden</md-button>
              <md-button class="md-raised" style="color:#C51162;"
                        @click.native="changeNavigate(false), $refs.mapSnackbar.open()">Ausprobieren</md-button>
            </div>
            <router-link style="width:100%;" to="/Info" >
              <span style="color:#fff;">Wie funktioniert tendu?</span>
            </router-link>
          </div>
        </div>
      </div>

      <md-dialog md-open-from="#custom" md-close-to="#custom" :md-click-outside-to-close="outside" ref="dialog1">
        <md-dialog-content>

          <div v-if="isNumber == '2'">

            <form novalidate @submit.stop.prevent="doLogin()">
              <span class="md-caption">Melde Dich an, um auf Dein Routenbuch und Deine Projekte zuzugreifen.</span>

                <md-input-container :class="errorClass">
                  <label>Benutzername</label>
                  <md-input required v-model="username" autocomplete="username"></md-input>
                  <span v-if="username" class="md-error"></span>
                  <span v-else class="md-error" >{{ signupConfig.requiredField }}</span>
                </md-input-container>

                <md-input-container :class="errorPass" md-has-password>
                  <label>Passwort</label>
                  <md-input required type="password" v-model="password" autocomplete="current-password"></md-input>
                  <span v-if="password" class="md-error"></span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>
                </md-input-container>

                <div style="text-align:right; margin-bottom:10px;">
                  <md-button @click.native="goCancel()" style="margin:auto !important;" class="md-accent">ABBRECHEN</md-button>
                  <md-button type="submit" class="md-accent" style="margin:auto !important;">ANMELDEN</md-button>
                </div>

                <p v-if="renderFriendlyMessage" class="md-caption warning">{{ renderFriendlyMessage }}</p>

                <span class="md-caption">Du hast noch kein Account? Dann schnell
                  <span class="userlink" @click="cleanMessage(), UPDATE_NUMBER(4)">Registrieren</span>
                </span>
                <br>
                <span class="md-caption">Passwort vergessen? Hier kannst Du Dein
                  <span class="userlink" id="custom" @click="UPDATE_NUMBER(3), cleanMessage(), openDialog('dialog1')">Passwort zurücksetzen</span >
                </span>

            </form>
          </div>

          <div v-else-if="isNumber == '1'" style="display:none;">
          </div>

          <!-- USER FORGOT PASSWORD -->
          <div v-else-if="isNumber == '3'">
            <form novalidate @submit.stop.prevent="">

              <p class="md-body-1">Bitte gib die Email-Adresse an,
                mit der Du dich bei uns angemeldet hast. Wir schicken Dir einen Link zu,
                mit dem Du Dein Passwort zurücksetzen kannst.</p>

                <md-input-container :class="errorMail">
                  <label>Email</label>
                  <md-input required type="email" v-model="userEmail" autocomplete="email"></md-input>
                  <span v-if="userEmail" class="md-error">{{ signupConfig.emailInvalid }}</span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>
                </md-input-container>

              <div style="text-align:right; margin:10px 0px;">
                <md-button @click.native="goCancel()" class="md-accent">ABBRECHEN</md-button>
                <md-button @click.native="forgotPassword()" class="md-accent">Passwort zurücksetzen</md-button>
              </div>

              <span class="md-caption">Du hast schon ein Konto?
                <a class="userlink" @click="UPDATE_NUMBER(2), cleanMessage()">Anmelden</a>
              </span>

              <br>
              <span class="md-caption">Du hast noch kein Account? Dann schnell
                <a class="userlink" @click="UPDATE_NUMBER(4), cleanMessage()">Registrieren</a>
              </span>
            </form>
          </div>

            <!-- USER REGISTRATION FORM -->
            <div v-else-if="isNumber == '4'">

              <form novalidate @submit.stop.prevent="createAccount()">
                <md-input-container :class="errorClass">
                  <label>Benutzername</label>
                  <md-input required v-model="newUser.name" autocomplete="username" @blur.native="isValidUsername()"></md-input>
                  <span v-if="isValidUsername || !newUser.name" class="md-error">{{ signupConfig.usernameInvalid }}</span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>

                </md-input-container>

                <md-input-container :class="errorPass">
                  <label>Passwort</label>
                  <md-input required v-model="newUser.password" type="password" autocomplete="new-password" @blur.native="errorMail=''"></md-input>
                  <span v-if="newUser.password" class="md-error">{{ signupConfig.passwordLength }}</span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>

                </md-input-container>

                <md-input-container :class="errorComp">
                  <label>Passwort wiederholen</label>
                  <md-input required v-model="newUser.repeatPass" autocomplete="new-password" @blur.native="errorMail='',checkPassword(),comparePasswords()" type="password"></md-input>
                  <span v-if="newUser.repeatPass" class="md-error">{{ signupConfig.passwordMatch }}</span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>
                </md-input-container>

                <md-input-container :class="errorMail">
                  <label>Email</label>
                  <md-input required type="email" @keyup="checkMailbox()" autocomplete="email" v-model="newUser.email"></md-input>
                  <span v-if="newUser.email" class="md-error">{{ signupConfig.emailInvalid }}</span>
                  <span v-else class="md-error">{{ signupConfig.requiredField }}</span>
                </md-input-container>

                <md-checkbox v-model="tosCheck"
                             @click="checkAgreements()"
                             class="md-caption" style="margin-bottom:3px;">
                    <span v-if="tosCheck" style="color:#C51162;" class="md-error"></span>

                </md-checkbox>
                <span class="md-caption">Ich habe die
                      <router-link to="/Policy" class="userlink">
                      Nutzungsbedingungen / Datenschutzerklärung
                    </router-link> gelesen.
                </span>
                    <br>

                <p v-if="!tosCheck" style="color:#C51162; margin-bottom:10px; margin-top:10px !important;" class="md-caption warning">{{ renderFriendlyMessage }}</p>

                <div style="text-align:right;">
                  <md-button @click.native="goCancel()"
                             class="md-accent" style="margin:0 !important; padding:0 8px;">ABBRECHEN</md-button>
                  <md-button type="submit" style="margin:0 !important; padding:0 8px;" class="md-accent">REGISTRIEREN</md-button>
                </div>

              </form><br>
              <div>
                <span class="md-caption">Du hast schon ein Konto?
                  <span class="userlink" @click="UPDATE_NUMBER(2), cleanMessage()">Anmelden</span>
                </span>
              </div>
            </div>

            <!-- USER REGISTRATION COMPLETE -->
            <div v-else-if="isNumber == '5'">
              <p class="md-title">{{ userDialogs.registratrionTitle }}</p><br>
              <p class="md-body-1">{{ userDialogs.registrationTextA }}
                <span style="color:#C51162;">{{ newUser.email }}</span>
              {{ userDialogs.registrationTextB }}</p><br>
              <p class="md-body-1">{{ userDialogs.registrationTextC }}</p>
              <div class="md-dialog-actions">
                <md-button class="md-accent" @click="closeDialog('dialog1'), cleanMessage()">OK</md-button>
              </div>
            </div>

            <!-- FORGOT PASSWORD AN EMAIL HAS BEEN SENT -->
            <div v-else-if="isNumber == '6'">
              <p class="md-subheading">Passwort zurückgesetzt</p>
              <p class="md-body-1">Wir haben Dir eine Email geschickt.</p>
              <p class="md-body-1">Bitte klick in den nächsten 60 Minuten auf den Link in der Email.</p>
              <div class="md-dialog-actions">
                <md-button class="md-primary" @click="closeDialog('dialog1'), UPDATE_NUMBER(1)">OK</md-button>
              </div>
            </div>

        </md-dialog-content>

      </md-dialog>
    </div>
    <md-snackbar class="md-primary" :md-position="vertical + ' ' + horizontal" ref="mapSnackbar" :md-duration="duration">
      <span>QR Code einer Route scannen oder Halle wählen.</span>
    </md-snackbar>

  </div>
</template>

<script>
// var EMPTY_STRING = ''
import { eventBus } from '../main'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

var OK_STRING = 'OK'
// var inputInvalidated = true

export default {
  name: 'home',

  data () {
    return {
      isLogin: false,
      outside: false,

      vertical: 'bottom',
      horizontal: 'center',
      duration: 4000,

      username: null,
      hashUser: '',
      password: null,
      userEmail: null,
      renderFriendlyMessage: '',
      newUser: {
        name: null,
        email: null,
        password: null,
        repeatPass: null
      },

      entryLink: '',
      validMail: '',

      errorClass: '',
      errorPass: '',
      errorComp: '',
      errorMail: '',
      errorCheck: '',

      inputInvalidated: true,

      // MESSAGES FOR LOGIN & REGISTER ACCOUNTS

      signupConfig: {
        customWorkspaceEnabled: false,
        customWorkspaceURI: '',
        appLoadingMessage: 'Du wirst angemeldet', // Loading Webclient...,
        appLoggingOutHint: 'Du wirst abgemeldet', // Logging out...,
        appStartPageURL: '/',
        appHomePageURL: '/',
        passwordLength: 'Passwort mindestens 8 Zeichen', // Your password must be at least 8 characters long.,
        passwordMatch: 'Die Passwörter sind nicht gleich', // Your passwords do not match.',
        checkTerms: 'Du musst die Nutzungsbedingungen / Datenschutzerklärung akzeptieren.', // First, please check our terms and conditions.,
        usernameInvalid: 'Ungültiger Benutzername', // This username would be invalid.,
        usernameTaken: 'Benutzername schon vergeben', // This username is already taken.,
        emailInvalid: 'Das ist keine gültige Mailadresse', // 'This E-Mail Address would be invalid.',
        emailTaken: 'Diese Mailadresse wird schon verwendet', // 'This E-Mail address is already registered.',
        notAuthorized: 'Login fehlgeschlagen. Benutzername oder Passwort falsch.', // 'You are not authorized. Sorry.',
        requiredField: 'Pflichtfeld', // 'The field is required.',
        notExistMail: 'Diese Email Adresse kennen wir nicht' // Email not resgistered
      },

      tosCheck: false,

      userDialogs: {
        registratrionTitle: 'Link zur Aktivierung per Mail verschickt',
        registrationTextA: 'Wir haben Dir eine E-Mail an ',
        registrationTextB: 'geschickt. Bitte überprüfe jetzt gleich Dein Postfach und klick auf den Aktivierungs-Link in der E-Mail. Danach ist Dein tendu Benutzerkonto freigeschaltet.',
        registrationTextC: 'WICHTIG: Bei manchen Providern (Googlemail / Hotmail / ...) kann die Mail im Spamordner landen. Bitte sieh dort nach, solltest Du keine Mail erhalten haben.',
        activationTitle: 'Aktivierungs-Link ungültig',
        activationProblem: 'Bitte entschuldige - da ist wohl was schief gegangen. Dieser Aktivierungs-Link ist leider nicht gültig. Bitte versuch erneut Dich zu registrieren. Sollte das nicht funktionieren, nimm bitte Kontakt mit uns auf.',
        creationTitle: 'Registrierung erfolgreich',
        creationAccount: 'Dein Benutzerkonto in tendu ist jetzt aktiv. Du kannst Routen als Projekte markieren, sie bewerten und in Dein Routenbuch eintragen. Dein Benutzername lautet:',
        confirmationText: 'Deine Registrierung wird geprüft',
        registrationError: 'Registrierung fehlgeschlagen. Bitte versuch es noch einmal.',
      }
    }
  },

  created () {
    this.loadEntryLink()
    eventBus.$on('startSite', (isNumber) => {
      this.UPDATE_NUMBER(isNumber)
      this.renderFriendlyMessage = ''
    })
  },

  computed: {
    ...mapState([
      'validUser',
      'isNavigate',
      'isNumber',
      'isBack',
    ]),
  },

  methods: {
    ...mapMutations([
      'changeNavigate',
      'UPDATE_NUMBER',
      'changeBack',
      'changeUserPrivileges',
      'changeValidUser',
      'changeNumberSector',
      'changeIsSetter',
      'changeIsManager'
    ]),

    openDialog(ref) {
      this.$refs[ref].open();
      this.changeBack(false)
    },

    closeDialog(ref) {
      this.$refs[ref].close()
      if (!this.validUser.hash) {
        this.UPDATE_NUMBER(1)
        this.changeBack(true)
      }
    },

    monitoringDialog () {
      eventBus.$on('startSite', (isNumber) => {
        // this.UPDATE_NUMBER(isNumber)
        if (isNumber = '4') {
          this.openDialog('dialog1')
        } else {
          this.renderFriendlyMessage = ''
        }
      })
    },

    onOpen() {
      // console.log('Opened')
    },
    onClose(type) {
      // console.log('Closed', type)
    },

    cleanMessage () {
      this.renderFriendlyMessage = ''
      this.username = null
      this.password = null
      this.newUser.name = null
      this.newUser.email = null
      this.newUser.password = null
      this.newUser.repeatPass = null
      this.tosCheck = false
      this.errorClass = ''
      this.errorPass = ''
      this.errorMail = ''
      this.userEmail = null
    },

    doLogin () {
      if (this.username === null || this.password === null) {
        this.errorClass = 'md-input-invalid'
        this.errorPass = 'md-input-invalid'
      } else {
        this.errorClass = ''
        this.errorPass = ''

        this.$http.get('climbo-backend/v1/hash/' + this.username)
          .then(response => {
            this.hashUser = response.data.hash
            // console.log('hash',response.data)
            this.changeValidUser(response.data)

            var authorization = this.authorization()
            if (authorization === undefined) {
              return null
            }

              this.$http.post('accesscontrol/login', '', { headers: { 'Authorization': authorization } })

                .then(response => {
                  if (response.body === '') {
                    this.renderFriendlyMessage = this.signupConfig.appLoadingMessage
                    this.changeBack(false)
                    this.redirectToStartPageURL()
                  }
                }, response => {
                  // error callback
                  this.renderFriendlyMessage = this.signupConfig.notAuthorized
                })
          })
      }
    },

    authorization () {
      try {
        var id = this.validUser.hash
        var secret = this.password
        return 'LDAP ' + window.btoa(id + ':' + secret) // IE >= 10 compatible

      } catch (error) {
        console.error('Error encoding Auth-Header', error)
      }
    },

    createAccount () {
      // any of these should prevent submission of form
      if (!this.isValidUsername()) {
        return false
      }
      if (this.checkPassword() !== OK_STRING) {
        return false
      }
      if (this.comparePasswords() !== OK_STRING) {
        return false
      }
      if (this.checkMailbox() === null) {
        return false
      }
      if (this.checkAgreements() !== OK_STRING) {
        return false
      }

      if (this.inputInvalidated) {
        this.checkUserNameAvailability()
      } else {
        this.doCreateRequest()
      }
    },

    doCreateRequest () {
      var usernameVal = encodeURIComponent(this.newUser.name)
      var mailbox = encodeURIComponent(this.newUser.email)
      var passwordVal = encodeURIComponent(window.btoa(this.newUser.password))
      var newAutho = usernameVal + '/' + passwordVal + '/' + mailbox

      this.$http.get('sign-up/create/' + newAutho)
        .then(function (response) {
          if (response.data.state === 'success') {
            this.errorClass = ''
            this.UPDATE_NUMBER('5')
            this.validMail = mailbox
          } else {
            this.errorClass = 'md-input-invalid'
          }
        })
    },

    isValidUsername () {
      if ((!this.newUser.name) || (this.newUser.name.length <= 2)) {
        this.errorClass = 'md-input-invalid'
        return false
      }
      this.errorClass = ''
      return true
    },

    checkPassword () {
      if ((!this.newUser.password) || (this.newUser.password.length <= 7)) {
        this.errorPass = 'md-input-invalid'
        return null
      }
      this.errorPass = ''
      return OK_STRING
    },

    comparePasswords () {
      if (this.newUser.password !== this.newUser.repeatPass) {
        this.errorComp = 'md-input-invalid'
        return null
      }
      this.errorComp = ''
      return OK_STRING
    },

    checkMailbox () {
      if (!this.newUser.email || this.newUser.email.indexOf('@') === -1 || this.newUser.email.indexOf('.') === -1) {
        this.errorMail = 'md-input-invalid'
        return null
      }
      this.errorMail = ''
      return OK_STRING
    },

    checkAgreements () {
      if (this.tosCheck) {
        this.renderFriendlyMessage = ''
        return OK_STRING
      }
      this.renderFriendlyMessage = this.signupConfig.checkTerms
      return null
    },

    checkUserNameAvailability (handler) {
      var userInput = encodeURIComponent(this.newUser.name)
      this.$http.get('sign-up/check/' + userInput, true)
        .then(function (response) {
          if (!response.body.isAvailable) {
            this.inputInvalidated = true
            this.errorClass = 'md-input-invalid'
            this.signupConfig.usernameInvalid = this.signupConfig.usernameTaken

            if (handler) handler(false)
          } else {
            this.errorClass = ''
            this.checkMailboxAvailability()
            if (handler) handler(true)
          }
        })
    },

    checkMailboxAvailability (handler) {
      var mailbox = encodeURIComponent(this.newUser.email)
      this.$http.get('sign-up/check/mailbox/' + mailbox, true)
        .then(function (response) {
          if (!response.body.isAvailable) {
            this.errorMail = 'md-input-invalid'
            this.inputInvalidated = true
            if (handler) handler(false)
          } else {
            this.errorClass = ''
            this.doCreateRequest()
            if (handler) handler(true)
          }
        })
    },

    loadEntryLink () {
      var userEntry = 'climbo-backend/v1/entrypoint'
      this.$http.get(userEntry)
        .then(function (response) {
          // console.log('entrypoint', response.data)
          if (!response.data.links.user) {
            this.UPDATE_NUMBER(1)
            this.isLogin = false
          } else {
            this.isLogin = true
            this.entryLink = response.data.links.user
            // console.log('the entrylink from entrypoint is', response.data)
            this.$http.get(this.entryLink)
              .then(function (response) {
                // console.log('success entryLink', response.data)
                this.changeUserPrivileges(response.data)
                this.changeValidUser(response.data)
                // console.log('validUser', this.validUser)
                // this.$store.state.validUser.userNick = response.data.userName

                if (response.data.sectorsAsRouteSetter[0]) {
                  this.changeIsSetter(true)
                  this.changeNumberSector(response.data.sectorsAsRouteSetter.length - 1)
                } else {
                  this.changeIsSetter(false)
                }

                if (response.data.sectorsAsSectorManager[0]) {
                  this.changeIsManager(true)
                  this.changeNumberSector(response.data.sectorsAsSectorManager.length - 1)
                } else {
                  this.changeIsManager(false)
                }

                this.$http.get('climbo-backend/v1/hash/' + this.username)
                  .then(response => {
                    this.changeValidUser(response.data)
                  })

                eventBus.$emit('loginStatus', this.isLogin, this.validMail)
                this.$router.push('/').catch(err => {})
              }, response => {
                console.log('not success entryLink')
              })
          }
        }, response => {
          this.UPDATE_NUMBER(1)
          this.changeIsSetter(false)
          // console.log('not success entrypoint')
        })
    },

    loadPrivileges () {
      this.$http.get(this.entryLink)
        .then(function (response) {
          console.log('success')
          this.changeUserPrivileges(response.data)
          console.log('userPrivileges', this.userPrivileges)
          if (response.data.sectorsAsRouteSetter[0]) {
            this.changeIsSetter(true)
            this.changeNumberSector(response.data.sectorsAsRouteSetter.length - 1)
            this.userEmail = response.data.email
          } else {
            this.userEmail = response.data.email
          }

          if (response.data.sectorsAsSectorManager[0]) {
            this.changeIsManager(true)
            this.changeNumberSector(response.data.sectorsAsSectorManager.length - 1)
            this.userEmail = response.data.email
          } else {
            this.userEmail = response.data.email
          }
        }, response => {
          this.changeIsManager(false)
          this.changeIsSetter(false)
          console.log('not success')
        })
    },

    goCancel () {
      this.UPDATE_NUMBER(1)
      this.cleanMessage()
      this.closeDialog('dialog1')
      this.changeBack(true)
      this.validUser.hash = null
    },

    redirectToStartPageURL () {
      this.isLogin = true
      setTimeout(() => {
        this.closeDialog('dialog1')
        this.UPDATE_NUMBER('9')
        this.loadEntryLink()
        eventBus.$emit('loginStatus', this.isLogin, this.validMail)
        this.$router.push('/').catch(err => {})
      }, 1500)

    },

    forgotPassword () {
      var emailAddress = this.userEmail.trim()
      if (!emailAddress || emailAddress.indexOf('@') === -1 || emailAddress.indexOf('.') === -1) {
        this.errorMail = 'md-input-invalid'
        return null
      } else {
        var mailbox = encodeURIComponent(this.userEmail)
        this.$http.get('sign-up/check/mailbox/' + mailbox, true)
          .then(function (response) {
            if (!response.body.isAvailable) {
              this.errorMail = ''
              this.$http.get('sign-up/password-token/' + emailAddress, true)
                .then(function (response) {
                  // console.log('Loaded Password Reset Response', response)
                  this.UPDATE_NUMBER(6)
                })
            } else {
              this.errorMail = 'md-input-invalid'
            }
          })
      }
    }
  }
}

</script>

<style scope>

  #home .list-container {
    color:white !important;
    max-width:max-content;
    margin:auto;
  }

  #home .md-display-3, #home .md-display-1{
    color:white !important;
    text-align:center;
    font-family: 'Advent Pro', sans-serif;
  }

  .backform .md-subheading {
    letter-spacing:0.03em;
  }

  .backform {
    position:fixed;
    width:100%;
    top:225px;
    z-index:9;
    padding-top:20px;
    padding-bottom: 20px;
    left:0px;
    height:240px;
    text-align:center;
    background-color: rgba(0, 131, 143, 0.7);
    }

  .backimage {
    position:relative;
    z-index:8;
    width:100%;
    height:400px;
    top:64px;
    background: url(../assets/tendu-wall-op.jpg) no-repeat !important;
    background-size: cover !important;
    background-position: center !important;
  }

  .user {
    width:100% !important;
    color: rgba(0, 0, 0, 0.87);
    background-color:#ffffff;
  }

  .md-caption.warning {
    color:#C51162 !important;
    font-weight:bold !important;
  }

</style>
